import { ErrorBoundary, type ErrorBoundaryProps } from 'react-error-boundary';
import { sentry } from '~features/logging';

type Props = React.PropsWithChildren;

const fallbackRender = () => null;

const onError: ErrorBoundaryProps['onError'] = (error, info) => {
  // eslint-disable-next-line no-console
  console.error(error);
  sentry.captureException(error, info);
};

export const SilentErrorBoundary = ({ children }: Props) => (
  <ErrorBoundary fallbackRender={fallbackRender} onError={onError}>
    {children}
  </ErrorBoundary>
);
